import type { ApiError } from "@/lib/api/client";

export function sanitizeApiFieldIdToken(field: string): string {
  const cleaned = field.replace(/[^a-zA-Z0-9_-]+/g, "-").replace(/^-+|-+$/g, "");
  return cleaned || "field";
}

export function apiFieldErrorId(idPrefix: string, field: string, index: number): string {
  return `${idPrefix}-${sanitizeApiFieldIdToken(field)}-${index}`;
}

export function apiFieldHasError(error: ApiError | null | undefined, field: string): boolean {
  return Boolean(error?.errors?.some((entry) => entry.field === field));
}

export function apiFieldDescribedBy(
  error: ApiError | null | undefined,
  field: string,
  idPrefix: string | undefined,
  fallbackId?: string,
): string | undefined {
  const ids: string[] = [];
  if (idPrefix) {
    error?.errors?.forEach((entry, index) => {
      if (entry.field === field) {
        ids.push(apiFieldErrorId(idPrefix, entry.field, index));
      }
    });
  }
  if (ids.length === 0) {
    return fallbackId;
  }
  if (fallbackId) {
    ids.push(fallbackId);
  }
  return ids.join(" ");
}
